declare global {
  interface Window {
    frontendENV: any;
  }
}

async function isBucketAvailable(staticBucketUrl) {
  const testUrl = staticBucketUrl + '/userImages/default/machine.jpg';
  try {
    const response = await fetch(testUrl);
    return response.ok;
  } catch (error) {
    console.warn('Error testing static bucket URL, falling back to bucket proxy.', error);
    return false;
  }
}

async function isWatermarkedBucketAvailable(watermarkedBucketUrl) {
  const testUrl = watermarkedBucketUrl + '/watermarked/logo192.png';
  try {
    const response = await fetch(testUrl);
    return response.ok;
  } catch (error) {
    console.warn('Error testing watermarked bucket URL, falling back to bucket proxy.', error);
    return false;
  }
}

export async function checkBucketsAvailability(log = false) {
  let staticBucketReachable = false;
  let watermarkedBucketReachable = false;
  if (window.frontendENV?.WATERMARKED_BUCKET) {
    watermarkedBucketReachable = await isWatermarkedBucketAvailable(window.frontendENV.WATERMARKED_BUCKET);
    if (log) {
      console.info(
        `Watermarked bucket URL is reachable: ${window.frontendENV.WATERMARKED_BUCKET}`,
        watermarkedBucketReachable,
      );
    }
  }

  if (window.frontendENV?.STATIC_BUCKET) {
    staticBucketReachable = await isBucketAvailable(window.frontendENV.STATIC_BUCKET);
    if (log) {
      console.info(`Static bucket URL is reachable: ${window.frontendENV.STATIC_BUCKET}`, staticBucketReachable);
    }
  }

  return {
    watermarkedBucketReachable,
    staticBucketReachable,
  };
}
